<!-- Macbook content  -->
<div class="full-screen">
  <div #loader id="loader">
    <div class="loader-content">
      <div class="loader-dots">
        <div class="dot red"></div>
        <div class="dot yellow"></div>
        <div class="dot green"></div>
      </div>
      <div class="loader-text">Loading...</div>
    </div>
  </div>

  <div
    #macbook
    id="macbook"
    class="macbook transparent hide"
    (mouseover)="hover()"
  >
    <div class="macbook-base">
      <div class="macbook-base-top">
        <div></div>
        <div class="macbook-base-top-keyboard"></div>
        <div class="macbook-base-top-mousepad"></div>
      </div>
      <div class="macbook-base-front"></div>
    </div>
    <div class="macbook-lid">
      <div class="macbook-screen-behind"></div>
      <div class="macbook-screen-top"></div>
      <div class="macbook-screen">
        <div class="macbook-content">
          <main id="main">
            <!-- <div id="login"></div> -->
            <!--<canvas
              id="matrix"
              class="screen-fixed"
              width="1440"
              height="900"
            ></canvas>-->

            <div id="menu">
              <div class="menu-apple"></div>
              <div class="menu-app">{{ application() }}</div>
              <div class="menu-date">
                {{ currentDate() | date: "EEE. d MMM. hh:mm:ss" }}
              </div>
            </div>

            <div id="terminal" class="window">
              <div class="window-bar">
                <div class="dot red"></div>
                <div class="dot yellow"></div>
                <div class="dot green"></div>
              </div>
              <div class="window-content">
                <div class="typewriter"></div>
              </div>
            </div>

            <!-- <div id="profile"><canvas></canvas></div> -->
            <div id="results" class="window">
              <div class="window-bar">
                <div class="dot red"></div>
                <div class="dot yellow"></div>
                <div class="dot green"></div>
              </div>
              <div class="window-content">
                <!--<div class="typewriter"></div>-->
                <iframe
                  loading="lazy"
                  src="./curriculumvitae.html"
                  frameborder="0"
                ></iframe>
              </div>
            </div>

            <!-- <div class="noise-white screen-fixed"></div>
                        <div class="noise-black screen-fixed"></div> -->
            <!-- <div class="screen-pixels screen-fixed"></div> -->
            <ul id="macbook-apps" class="macbook-apps">
              <li class="macbook-app"></li>
              <li class="macbook-app"></li>
              <li class="macbook-app"></li>
              <li class="macbook-app"></li>
              <li class="macbook-app"></li>
              <li class="macbook-app"></li>
              <li class="macbook-app"></li>
            </ul>
          </main>
        </div>
      </div>
    </div>
  </div>
</div>
